import { Dispatch } from "redux"
import IDispatcher from "../../../../../Util/IDispatcher"
import { ActionType as FilterActionType } from "../../../Main/Filter/Actions/ActionTypes"
import HeaderDispatch from "./model"
import HeaderUI from "./HeaderUI"
import { connect } from "react-redux"
import { ActionType as BookmarkAction } from "../../../Main/Bookmark/Actions/ActionTypes"
import { ActionType as SeenAction } from "../../../Main/LastSeen/Actions/ActionTypes"
import { ActionType as AllMoshaveranAction } from "../../../Main/AllMoshaveran/Actions/ActionTypes"
import { ActionType } from "../../Actions/ActionTypes"
import HeaderState from "../../State/HeaderState"
import ApplicationState from "../../../../../../ApplicationState"
import IState from "../../../../../Util/IState"

const mapStateToProps = (state: ApplicationState): IState<HeaderState> => {
    return {
        state: state.header
    }
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<HeaderDispatch> => ({
    dispatcher: {
        filter: () => {
            dispatch({
                type: FilterActionType.FILTER_IS_OPEN,
                isOpen: true
            })
        },
        bookmark : () => {
            dispatch({
                type: BookmarkAction.BOOKMARK_SHOW
            })
        },
        seen : () => {
            dispatch({
                type: SeenAction.SEEN_SHOW
            })
        },
        moshaveran : () => {
            dispatch({
                type: AllMoshaveranAction.ALL_MOSHAVERAN_SHOW
            })
        },
        onMenuClicked: () => { dispatch({ type: ActionType.ON_MENU }) },

    }
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderUI)